import {
  HUB_COP_TOUR_STEPS,
  type HubCopTourStepId,
} from './hubCopTourSteps';

/**
 * The tour runs outside React, so Layers hosts register the UI moves they
 * alone can perform. Everything is optional: a step whose host is not mounted
 * simply has nothing to reveal (centered popover).
 */
export type HubCopTourApi = {
  /** Close Review queue / draft panels (LayersViewContent). */
  closeSidePanels: () => void;
  showOverview: () => void;
  openFirstLayerDetail: () => void;
  openReviewQueue: () => void;
  ensureLayerExpanded: () => void;
  openSymbology: () => void;
};

let api: Partial<HubCopTourApi> = {};

export function registerHubCopTourApi(
  partial: Partial<HubCopTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof HubCopTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getHubCopTourApi(): Partial<HubCopTourApi> {
  return api;
}

/** Puts the screen in the state the step highlights. */
export function prepareHubCopStep(id: HubCopTourStepId) {
  const host = getHubCopTourApi();
  const def = HUB_COP_TOUR_STEPS.find((step) => step.id === id);

  switch (id) {
    case 'sectionIntro':
    case 'hubModel':
    case 'cop001':
    case 'cop003Zoom':
      host.closeSidePanels?.();
      host.showOverview?.();
      return;
    case 'cop002':
    case 'cop004':
      host.closeSidePanels?.();
      host.openFirstLayerDetail?.();
      return;
    case 'cop003Approval':
      host.openReviewQueue?.();
      return;
    case 'cop005':
      host.closeSidePanels?.();
      host.showOverview?.();
      host.ensureLayerExpanded?.();
      host.openSymbology?.();
      return;
    case 'focFeedback':
      host.closeSidePanels?.();
      host.showOverview?.();
      return;
    default:
      if (def?.tour) {
        host.closeSidePanels?.();
        host.showOverview?.();
      }
  }
}

/** Test helper to clear the module-level bridge. */
export function resetHubCopTourBridgeForTests() {
  api = {};
}
